import React from 'react';

const ParkingAreaFixedTimePage = () => {
    return (
        <div>
            
        </div>
    );
};

export default ParkingAreaFixedTimePage;